import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { checkoutRouter } from './routing/checkoutRouter'
import { checkoutAdminRouter } from './routing/checkoutAdminRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'checkout',
  totem: {
    tool: 'checkout-dashboard-tool',
  },
  routes,
  translations: {},
  lazyTranslations: {
    EN_US: () => import('./translations/en-US.json'),
    // Uncomment to lazy load your domain's foreign dictionaries
    // ES_ES: () => import('./translations/es-ES.json'),
    // FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    scoped: [checkoutRouter],
    admin: [checkoutAdminRouter],
  },
  navigationEntries: [],
  adminNavigationEntries: [],
  // NOTE TO DEV: run `pnpm ipp domain register <your-system-name>` to register your domain with Totem here
}

export default definition
